<template>
    <div>
        <div class="btn info-course-button text-start ps-5 p-3 mb-5">
            <h4>Selected Information session - </h4>
            {{dayFormat}} at {{startTimeFormat}} - {{endTimeFormat}}
        </div>
    </div>
</template>

<script setup>
import { format } from 'date-fns';
import { parse } from 'date-fns';
import { computed } from 'vue';

const props = defineProps({
    formData: Object
})

let dayFormat = computed(() => {
    return format(new Date(props.formData.start_date), 'EEEE do LLLL yyyy')
})
let startTimeFormat = computed(() => {
    return format(parse(props.formData.start_time, 'HH:mm', new Date()), 'h:mm a')
})
let endTimeFormat = computed(() => {
    return format(parse(props.formData.end_time, 'HH:mm', new Date()), 'h:mm a')
})
</script>
<style scoped>
.info-course-button {
    cursor: initial;
    font-weight: 500;
    width:100%;
    box-shadow: 4px 5px 22px 7px rgba(158,158,158,0.21);
    text-decoration: none;
    background: white;
}
</style>
